import { useEffect, useRef, useState } from "react";
import { getTop10Groups } from "../../services/firestore/SGloopService";
import SGLoopCard from "../SGLoop/SGLoopCard";

export default function ThirdSection() {
    const [top10Groups, setTop10Groups] = useState([]);

    useEffect(() => {
        const fetchTop10Groups = async () => {
            try {
                const groups = await getTop10Groups();
                console.log(groups)
                setTop10Groups(groups);
            } catch (error) {
                console.error("Error fetching groups:", error);
            }
        }
        fetchTop10Groups();
    }, [])

    const scrollRef = useRef(null);

    // Drag-to-scroll handlers
    const handleMouseDown = (e) => {
        const slider = scrollRef.current;
        slider.isDown = true;
        slider.startX = e.pageX - slider.offsetLeft;
        slider.scrollLeftStart = slider.scrollLeft;
    };
    const handleMouseLeave = () => (scrollRef.current.isDown = false);
    const handleMouseUp = () => (scrollRef.current.isDown = false);
    const handleMouseMove = (e) => {
        const slider = scrollRef.current;
        if (!slider.isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - slider.startX) * 2; // drag speed
        slider.scrollLeft = slider.scrollLeftStart - walk;
    };

    return (
        <section className="py-4">
            <div className="max-w-7xl mx-auto px-6">
                {/* Header */}
                <div className="text-center max-w-2xl mx-auto mb-12">
                    <span className="inline-block text-base font-semibold bg-slate-600 text-white px-6 py-1 rounded-full mb-4">
                        Communities
                    </span>
                    <h2 className="text-3xl md:text-4xl font-bold tracking-tight">
                        Connect with Like-Minded People
                    </h2>
                    <p className="mt-4 text-slate-500 leading-relaxed">
                        NextLoop Community loops connection, collaboration, and idea-sharing. Designed to bring people together across Singapore, it allows individuals to join vibrant groups, exchange insights, and engage with like-minded peers. More than just a social platform, it’s where future partners, innovators, and changemakers discover opportunities, build relationships, and shape ideas that can grow into real-world impact. Explore communities, find your tribe, and be part of a network that spans the entire nation.
                    </p>
                </div>

                {/* Horizontal Scroll Cards */}
                <div
                    ref={scrollRef}
                    className="flex gap-6 overflow-x-auto scrollbar-hide  px-2 cursor-grab active:cursor-grabbing"
                    onMouseDown={handleMouseDown}
                    onMouseLeave={handleMouseLeave}
                    onMouseUp={handleMouseUp}
                    onMouseMove={handleMouseMove}
                >
                    {top10Groups.map((community) => (
                        <div
                            key={community.id}
                            className="flex-shrink-0 w-72 sm:w-80 md:w-96 rounded-2xl p-6 transition"
                        >
                            <SGLoopCard community={community} />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
